import { BuildingStore } from "@mobx/store/locations/interfaces";
import { IDragRackItemData3 } from "@mobx/store/locations/types";
import unallocatedMinersStore from "@mobx/store/locations/unallocated";

interface DropRackItemToUnallocatedParams {
  readonly buildingStore?: BuildingStore;
  readonly onMergedError: () => void;
  readonly rackItemData: IDragRackItemData3;
}

export const dropRackItemToUnallocated = async ({
  buildingStore,
  onMergedError,
  rackItemData,
}: DropRackItemToUnallocatedParams) => {
  if (rackItemData.merge && rackItemData.merge.length > 1) {
    onMergedError();
    return false;
  }

  const res = await unallocatedMinersStore.dropItem(rackItemData);
  if (!res) return false;

  buildingStore?.rackStores.get(+rackItemData.prevRackId)?.removeItem(rackItemData.id);
  buildingStore?.setCanUndo();
  await buildingStore?.reload();
  return true;
};
